import * as o from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/Chat.es.js";
const t = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: m }));
t.displayName = "ChatIcon";
const n = t;
export {
  n as Chat,
  t as ChatIcon
};
